import React, { useContext, useState, useEffect } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import TransactionContext from '@/product/context/transaction/transactionContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { useFormik } from 'formik'

const MembershipLogs = (props) => {
    const transactionContext = useContext(TransactionContext)
    const [isLoading, setIsLoading] = useState(true)
    const {
        all_membership_logs,
        getAllMemberShipLogs,
        responseStatus: responseStatusInvoice,
        clearResponse: clearResponseInvoice,
    } = transactionContext

    let action = props.action ? props.action : ''

    const [tableBody, setTableBody] = useState([])

    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            fielddate: 'usm.date_added',
            fromdate: '',
            todate: '',
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                customer: {
                    value: '',
                    type: 'like',
                    field: 'u.first_name,u.last_name,u.username',
                },
                userId: {
                    value: '',
                    type: 'in',
                    field: 'usm.user_id',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllMemberShipLogs(values)
        },
    })

    useEffect(() => {
        if (all_membership_logs) {
            setTableBody(
                all_membership_logs.records.length
                    ? all_membership_logs.records
                    : []
            )
        }
        setIsLoading(false)
    }, [all_membership_logs])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1
        formik.values.fromdate = ''
        formik.values.todate = ''
        formik.values.searchterm = ''
        formik.values.filters.userId.value = props.userId ? props.userId : ''
        getAllMemberShipLogs(formik.values)
        /* return () => {
            setTableBody([])
        }*/
    }, [action])

    const resetForm = () => {
        formik.values.action = action
        formik.values.page = 1
        formik.values.fromdate = ''
        formik.values.todate = ''
        formik.values.filters.customer.value = ''
        formik.values.filters.userId.value = props.userId ? props.userId : ''
        getAllMemberShipLogs(formik.values)
    }

    const tableValues = [
        {
            field: 'user_id',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'User ID',
        },
        {
            field: 'trans_id',
            type: '',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Transaction ID',
        },
        {
            field: 'amount',
            type: 'price',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Amount',
        },
        {
            field: 'first_name,last_name',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Name',
        },
        {
            field: 'username',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Username',
        },
        {
            field: 'date_added',
            type: 'date',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Created Date',
        },
    ]

    const tableActions = []

    const searchInfo = [
        {
            label: 'Name',
            placeholder: 'Enter Name',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'customer',
            formik: formik,
            filter: true,
        },
        {
            label: 'Created From Date',
            placeholder: 'Date Ending from',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'date',
            name: 'fromdate',
            formik: formik,
        },
        {
            label: 'Created To Date',
            placeholder: 'Date Ending To',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'date',
            name: 'todate',
            formik: formik,
        },
    ]

    return (
        <>
            {' '}
            <div className="invoice_tab">
                <CustomSearch
                    searchInfo={searchInfo}
                    formik={formik}
                    advFilters={true}
                    resetForm={resetForm}
                />
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={all_membership_logs}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllMemberShipLogs}
                    hideCompactView={true}
                />
            </div>
        </>
    )
}

export default MembershipLogs
